import { baseRoutes } from '@routes/helpers/baseRoutes.ts';
import { routesPaths } from '@routes/helpers/constants.ts';
import { AppRouteConfig } from '@routes/route';

export const responsesRoutes: ReadonlyArray<AppRouteConfig> = [
  {
    path: baseRoutes.responses.root,
    lazyImport: () => import('../../domains/protected/responses/ResponsesRoute.tsx'),
    requiresAuth: true,
    resourceId: 'response',
    children: [
      {
        index: true,
        lazyImport: () =>
          import('../../domains/protected/responses/pages/responses-list/ResponsesListRoute.tsx'),
        nav: {
          hideBack: true,
          breadcrumbKey: 'list'
        }
      },
      {
        path: baseRoutes.responses.details,
        lazyImport: () =>
          import('../../domains/protected/responses/pages/response-details/ResponseDetailsRoute.tsx'),
        nav: {
          backTo: routesPaths.responses.root,
          breadcrumbKey: 'details'
        }
      },
      {
        path: '*',
        redirectTo: baseRoutes.responses.root
      }
    ]
  }
];
